import { z } from 'zod';
import { languages } from '../enums/identity.js';

/**
 * Suggestions d'adresses pendant la saisie — « Commencez à taper pour voir les suggestions
 * d'adresses », le geste de la V1.
 *
 * Le navigateur ne parle qu'à notre serveur. Le serveur relaie à la passerelle géographique de
 * PhysioPro (`GEO_GATEWAY_URL`), qui seule détient la clé du fournisseur, Geoapify. La saisie est
 * souvent l'adresse d'un patient : elle n'est jamais journalisée.
 */

/** En dessous de trois caractères, toute rue correspond : ni le front ni le serveur n'appellent. */
export const ADDRESS_QUERY_MIN_LENGTH = 3;
export const ADDRESS_QUERY_MAX_LENGTH = 200;
/** Suggestions demandées à la passerelle, et rendues au plus. */
export const ADDRESS_SUGGESTIONS_MAX = 8;
/**
 * Plafond journalier annoncé par la passerelle, partagé entre tous les cabinets. La console
 * l'affiche ; elle ne le change pas — il se négocie avec PhysioPro, pas dans un écran.
 */
export const ADDRESS_LOOKUP_DAILY_QUOTA = 3000;

export const addressSuggestQuerySchema = z
  .object({
    q: z.string().trim().min(ADDRESS_QUERY_MIN_LENGTH).max(ADDRESS_QUERY_MAX_LENGTH),
    /** La langue de l'interface : celle des libellés rendus. */
    lang: z.enum(languages).default('fr'),
  })
  .strict();
export type AddressSuggestQuery = z.infer<typeof addressSuggestQuerySchema>;

/**
 * Une adresse suggérée, sous les six champs du contrat de la passerelle et eux seuls. `libelle`
 * est la ligne complète, pour la liste ; le reste remplit le formulaire — `libelle` ne va jamais
 * dans le champ rue.
 */
export interface AddressSuggestionDto {
  libelle: string;
  numero: string | null;
  rue: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export interface AddressSuggestionsDto {
  suggestions: AddressSuggestionDto[];
}
